export const ROOT = '';
export const APP = 'App';
export const OFICINA_VIRTUAL = 'Oficina-virtual';
export const SITIO_PUBLICO = 'Sitio-publico';
export const REPORTES = 'Reportes';
export const HOME = 'Login';
